import VeeValidate from 'vee-validate';
import Vue from 'vue';

Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'formFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'errors',
});
